module.exports = __webpack_public_path__ + "img/uj_03.f60508bf.jpg";